/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Json_JsonInputs */

const en_json_json = /** @type {(inputs: Json_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON (.json)`)
};

const fr_json_json = /** @type {(inputs: Json_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON (.json)`)
};

const de_json_json = /** @type {(inputs: Json_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON (.json)`)
};

const it_json_json = /** @type {(inputs: Json_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON (.json)`)
};

const ru_json_json = /** @type {(inputs: Json_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON (.json)`)
};

const es_json_json = /** @type {(inputs: Json_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON (.json)`)
};

const zh_cn2_json_json = /** @type {(inputs: Json_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON（.json）`)
};

const ja_json_json = /** @type {(inputs: Json_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON (.json)`)
};

const hi_json_json = /** @type {(inputs: Json_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON (.json)`)
};

const pt_pt2_json_json = /** @type {(inputs: Json_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON (.json)`)
};

/**
* | output |
* | --- |
* | "JSON (.json)" |
*
* @param {Json_JsonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const json_json = /** @type {((inputs?: Json_JsonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Json_JsonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_json_json(inputs)
	if (locale === "de") return de_json_json(inputs)
	if (locale === "it") return it_json_json(inputs)
	if (locale === "ru") return ru_json_json(inputs)
	if (locale === "es") return es_json_json(inputs)
	if (locale === "zh-CN") return zh_cn2_json_json(inputs)
	if (locale === "ja") return ja_json_json(inputs)
	if (locale === "hi") return hi_json_json(inputs)
	if (locale === "pt-PT") return pt_pt2_json_json(inputs)
	return en_json_json(inputs)
});